<!--<div class="brk-loader">
    <div class="brk-loader__loader"></div>
</div>-->
<app-carregador></app-carregador>

<div class="main-page" [style.visibility]="visibilidade">
    <div class="main-wrapper">
        <main class="main-container">
            <section>
                <div class="row no-gutters">
                    <div class="col-12 col-lg-5 d-lg-block d-none">
                        <div
                            class="full-screen position-relative d-flex flex-column justify-content-center align-items-center z-index-2">
                            <div class="brk-backgrounds brk-base-bg-gradient-15x brk-abs-overlay"
                                data-brk-library="component__backgrounds_css,component__backgrounds_js,assets_particleground">
                                <div class="brk-backgrounds__canvas brk-particles-standart"></div>
                            </div>
                            <a href="https://smosc.com.br/" class="z-index-2 mb-60 pl-15 pr-15">
                                <img src="assets/imagens/logo-smo-total-1.png" alt="logo" class="">
                            </a>
                            <a href="https://smosc.com.br/"
                                class="btn-backgrounds btn-backgrounds_transparent btn-backgrounds_left-icon font__family-montserrat font__weight-normal text-uppercase font__size-13 z-index-2 text-center"
                                style="padding-left:85px; padding-right: 60px;" data-brk-library="component__button">
                                <span class="text">VOLTAR AO INÍCIO</span>
                                <span class="before"><i class="fas fa-arrow-left"></i></span>
                            </a>
                        </div>
                    </div>
                    <div class="col-12 col-lg-7">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </section>
        </main>
    </div>
</div>

<footer class="app-footer">
    <div class="app-footer__content">
        <span *ngIf="version" class="app-footer__version">v{{ version }}</span>
    </div>
</footer>

<a href="#top" id="toTop"></a>